module.exports = __webpack_public_path__ + "static/media/loader.cbd9fc28.svg";